import React from "react";
import PropTypes from "prop-types";
import { ReactComponentStaticProps } from "../../types/react";
import { Image } from "../Image";

import styles from "./ComparisonTable.scss";

type ComparisonTableImageBaseProps = {
  src: string;
  alt: string;
};

export type ComparisonTableImageProps = ComparisonTableImageBaseProps &
  Omit<
    React.ComponentPropsWithoutRef<"img">,
    keyof ComparisonTableImageBaseProps
  >;

export const ComparisonTableImage: ((
  props: ComparisonTableImageProps
) => JSX.Element) &
  ReactComponentStaticProps<ComparisonTableImageProps> = ({
  src,
  alt,
  ...restProps
}) => {
  return <Image className={styles.image} src={src} alt={alt} {...restProps} />;
};

ComparisonTableImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

ComparisonTableImage.displayName = "ComparisonTable.Image";

export default ComparisonTableImage;
